// extracted by extract-css-chunks-webpack-plugin
module.exports = {"icon":"icon___x8ffQ"};